import React from 'react';
import { DiagnosticsModule } from './DiagnosticsModule';
import { CheckCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
export function AIAndDiagnosticsSection() {
  const {
    t
  } = useTranslation();
  return <section className="bg-white dark:bg-black py-20" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-39">
          {/* Left Column: AI Assessment */}
          <div data-id="element-40">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-41">
              AI-Powered Device Assessment
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8" data-id="element-42">
              Our advanced AI technology accurately evaluates device condition,
              ensuring fair and competitive trade-in values.
            </p>
            <div className="space-y-4" data-id="element-43">
              {['Visual inspection detects scratches, dents, and screen damage', 'Functional testing for all device components', 'Market-based pricing algorithms for maximum value', 'Instant quotes in under 2 minutes'].map((feature, index) => <div key={index} className="flex items-start" data-id="element-44">
                  <CheckCircleIcon className="h-5 w-5 text-blue-500 dark:text-brand-green mr-2 mt-0.5 flex-shrink-0" data-id="element-45" />
                  <p className="text-gray-700 dark:text-gray-300" data-id="element-46">{feature}</p>
                </div>)}
            </div>
          </div>
          {/* Right Column: Diagnostics Module */}
          <div className="relative" data-id="element-47">
            <DiagnosticsModule data-id="element-48" />
          </div>
        </div>
      </div>
    </section>;
}